<template>
  <v-container>
    <v-row>
      <v-col cols="12" md="3">
        <h3>Filters</h3>
        <v-text-field
          v-model="recTitle"
          label="Recording title"
          clearable
        ></v-text-field>
      </v-col>
      <v-col cols="12" md="6">
        <div class="overline ">
          <router-link class="primary--text" to="/home">home</router-link> >
          tunes
        </div>
        <h1 class="title-logo primary--text">Recordings</h1>
        <p>Showing {{ filtRecordings.length }} recordings</p>
        <v-row>
          <v-col cols="12" md="6" v-for="(rec, i) in filtRecordings" :key="i">
            <v-card class="" :to="'recordings/' + rec.id">
              <v-card-title>
                {{ rec.title }}
              </v-card-title>
              <v-card-text>
                <v-chip v-for="(tune, idx) in rec.tunes" :key="idx">
                  {{  tune.title }}
                </v-chip>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
// import TutoInfo from '@/layout/TutoInfo.vue';

  // import TradPlayer from '@/components/TradPlayer'

  export default {
  name: 'RecordingList',
  data: function () {
    return {
      playIndex: 0,
      recTitle: '',
    }  
  },
  computed: {
    recordings: {
      get() {
        return this.$store.state.tune.recordings;
      }
    },
    filtRecordings() {
      if (!this.recTitle || this.recTitle == '')
        return this.recordings;
      var vm = this;
      return this.recordings.filter(function (el) {
        if (el.title.toLowerCase().indexOf(vm.recTitle.toLowerCase()) > -1) {
          return el;
        }
      })
    },
  },
  components: {
    // TradPlayer,
    // TutoInfo
  },
  mounted() {
    this.$store.dispatch('tune/getRecordingList');
  },
  methods: {
    // this.s
  },
  filters: {
    capitalize(val) { 
     return String(val).charAt(0).toUpperCase() + String(val).slice(1);
    }
  }
}
</script>
<style lang="scss" scoped>
@import '~vuetify/src/styles/styles.sass';
.has-recording {
  border: 2px solid var(--v-primary-base);
}
.v-card { 
  transition: transform 0.2s ease-in-out;
}
.v-card:hover {
  transform: scale(1.1);
    .v-image__image--cover { 
      // transform: scale(1.1);
    }
}
</style>